import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Image, message, Popconfirm, Table, Button, Dropdown, Menu, Pagination, ConfigProvider } from "antd";
import { Icon } from "@iconify/react/dist/iconify.js";

import { MakeApiCall } from "../../../apis";
import { DefaultAdminPage,  DefaultUserPage,  Types,} from "../../../config";

import { fakeImage } from "../../../config/fakeData";


import UserModal from "./user-config";
import { Helmet } from "react-helmet";

const findRoutes = {
  admin: DefaultAdminPage,
  user: DefaultUserPage,
};

export default function UserList(props) {




  const { setData, userData } = props;

  const navigate = useNavigate();

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  const [searchText, setSearchText] = useState("");


  const getUserList = async (data) => {
    setLoading(true);
    const response = await MakeApiCall(
      `users?search_text=${data?.searchText || searchText}&page=${data?.page || page || 1}&per-page=${data?.pageSize || pageSize}`, "get", null, true, {}, userData?.token );

    if (response?.status) {
      setTotalPage(response?.data?.pagination?.totalCount || 0);
      setPage(response?.data?.pagination?.page || 1);
      setList(response?.data?.records || []);
      setLoading(false);
    } else {
      message.warning(response?.message);
      setLoading(false);
      setList([]);
    }
  };

  const DeleteUser = async (id) => {
    message.destroy();
    message.loading("Loading...", 0);
    const response = await MakeApiCall(
      `user/${id}`,
      "delete",
      null,
      true,
      {},
      userData?.token
    );

    if (response?.status) {
      setLoading(true);
      getUserList();
      message.destroy();
      message.success(response?.message);
    } else {
      message.destroy();
      message.warning(response?.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    getUserList();

    return () => {};
  }, [page, pageSize, searchText]);

  const SwitchAccount = async (id) => {
    const response = await MakeApiCall(`switch-user`, "post", { id: id, }, true, {}, userData?.token );
    if (response?.status === true) {
      const type = Types?.[response?.data?.user_data?.user_type];
      const obj = {
        admin: userData,
        user: response?.data,
        loginType: type,
        token: response?.data?.auth_token_data?.access_token,
      };

      setData(obj);
      navigate(findRoutes?.[type]);
    } else {
      message.warning(response?.message);
    }
  };

  const [visible, setVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  
  const handleCancel = () => {
    setVisible(false);
    setEditingUser(null);
  };

  const CreateUser = async (data) => {
    message.destroy();
    message.loading("Loading...", 0);
    const response = await MakeApiCall(
      `sign-up`,
      "post",
      {
        ...data,
        user_type: 2,
      },
      true,
      {},
      userData?.token
    );

    if (response?.status === true) {
      handleCancel();
      setLoading(true);
      getUserList();
      message.destroy();
      message.success(response?.message || "Successfully created");
    } else {
      message.destroy();
      message.warning(response?.message || "Failed to create");
    }
  };
  const UpdateUser = async (data) => {
    if (!editingUser?.id) return;
    message.destroy();
    message.loading("Loading...", 0);
    const response = await MakeApiCall(
      `user/${editingUser?.id}`,
      "put",
      data,
      true,
      {},
      userData?.token
    );

    if (response?.status === true) {
      handleCancel();
      setLoading(true);
      getUserList();
      message.destroy();
      message.success(response?.message || "Successfully updated");
    } else {
      message.destroy();
      message.warning(response?.message || "Failed to update");
    }
  };

  const handleSubmit = (values) => {
    if (editingUser) {
      console.log("Updated values:", values, editingUser);
      // Handle update logic here
      UpdateUser(values);
    } else {
      CreateUser(values);
      console.log("Submitted values:", values);
      // Handle create logic here
    }
    setVisible(false);
    setEditingUser(null);
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setVisible(true);
  };

  // Columns configuration
  const handleSearch = (e) => {
    setSearchText(e.target.value);
    setPage(1); // Reset to the first page on new search
  };

  const columns = [
    
    {
      title: "Switch User",
      key: "switchUser",
      align: "center",

      render: (_, row) => (
        <Icon
          onClick={() => SwitchAccount(row?.id)}
          icon="clarity:switch-line"
          width={30}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, row) => (
        <div>
          <Button
            onClick={() => {
              handleEdit(row);
            }}
            type="link"
          >
            <Icon icon="basil:edit-outline" width={24} />
          </Button>
          <Popconfirm
            placement="left"
            title="Are you sure you want to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              DeleteUser(row?.id);
            }}
          >
            <Button type="link">
              <Icon
                icon="fluent:delete-20-filled"
                style={{ color: "#ff5454" }}
                width={24}
              />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      title: "#",
      key: "index",
      render: (text, record, index) => {
        return (page - 1) * pageSize + index + 1;
      },
    },

    {
      title: "User Details",
      dataIndex: "userDetails",
      key: "userDetails",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (_, record) => (
        
        <div className="d-flex align-items-center">
          <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
            <img src={record?.photo || fakeImage} alt />
          </div>
          <div className="d-flex flex-column">
            <Link href className="text-gray-800 text-hover-danger mb-1 fw-bolder">{record.name || ''}</Link>
            <span>{record.email || ''}</span>
          </div>
        </div>

      ),
    },
    {
      title: "Contact No.",
      dataIndex: "contact_no",
      key: "contact_no",
      render: (text) => (
       <span>{text || 'N/A'}</span>
      ),
    },
    {
      title: "Switch User",
      key: "switchUser",
      render: (_, row) => (
      
        <Link onClick={() => SwitchAccount(row?.id)} href="user-dashboard.html"
        className="d-flex align-items-center btn btn-danger justify-content-center  py-2 px-0 fs-7 fw-bolder w-150px">
        Switch User <i
          className="ki-outline ki-arrow-mix fs-1  ms-3"></i>
        </Link>
      ),
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      key: "created_at",
      render: (timestamp) => {
        const date = new Date(timestamp * 1000);
        return new Intl.DateTimeFormat('en-IN', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        }).format(date);
      },
    },
    {
      title: "Updated at",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (timestamp) => {
        const date = new Date(timestamp * 1000);
        return new Intl.DateTimeFormat('en-IN', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        }).format(date);
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <Dropdown overlay={menu(row)} trigger={["click"]}>
          <Button type="link" className="" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true" ><i className="ki-solid ki-dots-vertical fs-1 text-gray-800 "></i></Button>
        </Dropdown>
      ),
    },
  ];
  const menu = (row) => (
  <Menu className=" min-w-200px p-3">
    <Menu.Item key="1" className="d-flex align-items-center mb-2" onClick={() => handleEdit(row)}><i className="ki-outline ki-pencil fs-3 me-2"></i>Edit user</Menu.Item>
    <Menu.Item key="2" className="d-flex align-items-center"><i className="ki-outline ki-trash fs-3 me-2"></i>Delete user</Menu.Item>
  </Menu>
);

const theme = {
  token: {
    itemActiveBg: '#ffffff',
    itemActiveBgDisabled: 'rgba(0, 0, 0, 0.15)',
    itemActiveColorDisabled: 'rgba(0, 0, 0, 0.25)',
    itemBg: '#ffffff',
    itemInputBg: '#ffffff',
    itemLinkBg: '#ffffff',
    itemSize: 32,
    itemSizeSM: 24,
    miniOptionsSizeChangerTop: 0,
    colorBgContainer: '#ffffff',
    colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
    colorBgTextActive: 'rgb(255, 255, 255)',
    colorBgTextHover: 'rgb(255, 255, 255)',
    colorBorder: '#d9d9d9',
    colorPrimary: '#f45b68',
    colorPrimaryBorder: '#f45b68',
    colorPrimaryHover: '#f45b68',
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
   
  },
};


  return (
  
    <>
      <Helmet>
      <title>Manage User</title>
    </Helmet>

    <div className="mb-10 mx-n9 px-10 py-5 bg-white filter">
      <div className="position-relative ">
        <i className="ki-outline ki-magnifier text-gray-800 fs-2 position-absolute top-50 translate-middle-y ms-4" />
        <input type="text" value={searchText} onChange={handleSearch} data-kt-table-widget-4="search" className="form-control form-control-solid  text-dark  w-300px border border-gray-300 fs-7 ps-12 all-search" name="all_search" placeholder="Search by name or email..." />
      </div>
    </div>

    <div>
  {/*begin::Row*/}
  <div className="row gy-5 g-xl-5">
    {/*begin::Col*/}
    <div className="col-xxl-12">
      {/*begin::Tables Widget 9*/}
      <div className="card card-xxl-stretch mb-5 mb-xl-8">
        {/*begin::Header*/}
        <div className="card-header border-bottom-dashed">
          <h3 className="card-title fw-bolder">Users List</h3>
          <div className="card-toolbar">
          {/* <AddBTN onClick={() => setVisible(true)} type="primary">
             + Add User
    /     </AddBTN> */}
          </div>
        </div>
        {/*end::Header*/}
        {/*begin::Body*/}
        <div className="card-body py-2">
          {/*begin::Table container*/}
          <div className="table-responsive">
            {/*begin::Table*/}
            <Table 
            // className=" cus-table"
              scroll={{ x: "max-content" }}
              columns={columns1}
              loading={loading}
              dataSource={list}
              rowKey="key" 
              pagination={false}
              components={{
                table: (props) => (
                  <table className="table table-row-dashed table-row-gray-300 align-middle gs-4 gy-4 fs-7" {...props} />
                ),
                header: {
                  wrapper: (props) => <thead {...props} className="" />, // Override and provide an empty class
                  row: (props) => <tr {...props} className="fw-bolder text-dark bg-cus" />,
                  cell: (props) => (
                    <th {...props} className={``} />
                  ),
                },
              }}
            />
            {/*end::Table*/}
          </div>
          {/*end::Table container*/}
        </div>
        {/*begin::Body*/}
      </div>
      {/*end::Tables Widget 9*/}
    </div>
    {/*end::Col*/}
  </div>
  {/*end::Row*/}
  {/*begin::Row*/}
  <div className="row gy-5 g-xl-5">
    {/*begin::Col*/}
    <div className="col-xxl-12">
      {/*begin::Tables Widget 9*/}
      <div className="card card-xxl-stretch mb-5 mb-xl-8">
        {/*begin::Body*/}
        <div className="card-body py-2">
        <ConfigProvider theme={theme}>
                 <Pagination
                   className="mt-3"
                   current={page}
                   pageSize={pageSize}
                   total={totalPage}
                   showSizeChanger
                   onChange={(currentPage, newPageSize) => {
                     setPage(currentPage);
                     setPageSize(newPageSize);
                     getUserList({ page: currentPage, pageSize: newPageSize });
                   }}
                   showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                 />
               </ConfigProvider>
         
        </div>
        {/*begin::Body*/}
      </div>
      {/*end::Tables Widget 9*/}
    </div>
    {/*end::Col*/}
  </div>
  {/*end::Row*/}
</div>
    <UserModal
        visible={visible}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        initialValues={editingUser}
      />
    </>
  );
}
